/**
 * Obtiene la alineación guardada para un tipo de equipo (Local o Away).
 * @param {string} teamType - "Local" o "Away".
 * @returns {Promise<{success: boolean, data?: any, message?: string}>}
 */
const GetLineup = async (teamType) => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + `lineup/${teamType}`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { success: false, message: errorData.message || 'No ha sido posible obtener la alineación.' };
        }
        
        const responseData = await response.json();
        return { success: true, data: responseData.data };
    } catch (error) {
        return { success: false, message: 'Error de conexión. Revisa tu internet e inténtalo de nuevo.' };
    }
};

/**
 * Guarda la táctica, colores, DT y posiciones de los jugadores.
 * @param {Object} dataPayload - { teamType, teamId, formation, kitColor, managerName, players: [{ playerId, isCaptain, positionX, positionY }] }
 * @returns {Promise<{success: boolean, data?: any, message?: string}>}
 */
const SaveLineup = async (dataPayload) => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "lineup/save", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(dataPayload)
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { success: false, message: errorData.message || 'No ha sido posible guardar la alineación.' };
        }
        
        const responseData = await response.json();
        return { success: true, data: responseData.data };
    } catch (error) {
        return { success: false, message: 'Error de conexión al guardar la alineación.' };
    }
};

/**
 * Dispara un evento de presentación estelar para el Overlay.
 * @param {Object} dataPayload - { action: string, playerId: number|null }
 * @returns {Promise<{success: boolean, data?: any, message?: string}>}
 */
const TriggerPresentation = async (dataPayload) => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "lineup/trigger", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(dataPayload)
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { success: false, message: errorData.message || 'No ha sido posible disparar la presentación.' };
        }
        
        const responseData = await response.json();
        return { success: true, data: responseData };
    } catch (error) {
        return { success: false, message: 'Error de conexión al disparar el evento.' };
    }
};

export { GetLineup, SaveLineup, TriggerPresentation };